import axios from 'axios';

const getPlaylists = function getYouTubePlaylists(ministryId, lang, page) {
  const url = `https://www.twr360.org/programs/jsonFeed/ministry_id,${ministryId}/language_id,${lang}?page=${page}`;
  return axios
    .get(url)
    .then(res => res)
    .catch(err => err);
};

export default getPlaylists;



// WEBPACK FOOTER //
// ./src/components/getMinistryData/getMinistryData.js